export const istqbCoursesCount = 5;
export const specializedCoursesCount = 12;